import { Trans } from "@lingui/react";
import * as React from 'react';
import { Button } from '~ui/components/buttons/Button/Button';
import { IconArrowRight } from '~ui/components/icons/specific/IconArrows';
import { Text } from '~ui/components/typography/Text/Text';
import { useWaiterRouter } from '../../Routing/client';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Button that navigates to the menu screen.
 */
export var OrderButton = function OrderButton() {
  var router = useWaiterRouter();
  var navigateToMenu = React.useCallback(function () {
    router.push("menu");
  }, [router]);
  return /*#__PURE__*/_jsx(Button, {
    size: "large",
    width: "100%",
    onClick: navigateToMenu,
    bgColor: "conversion",
    rightIcon: {
      icon: IconArrowRight
    },
    children: /*#__PURE__*/_jsx(Text, {
      fontSize: "m18",
      fontStyle: "boldSemi",
      children: /*#__PURE__*/_jsx(Trans, {
        id: "kFjzAQ"
      })
    })
  });
};